var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#pattern0_1187_766)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1187_766",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1187_766",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1187_766",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABXUlEQVR4nO2YwUrDQBCGvxy868W+gq2+Q6V6sIpP4UN43efoW1iPQkvfQizxpEcDeq5UArOwhGTdJEuSwnwwUDLbmX83P4EdUBRFEU6AR+AZeKmIpaw5ZmBcAJ/APjA+gHMGwhHwVkO8jVf5b+/cO6K+gQfguiLy3I+z/q4rkQkwAa5KRC0cQU8e8TaWzvpFST7vMZaeUchP6b2BRdpGCtzGEP/bg/i9xA6YNxWfyCnYYl/ASj6H7vPU89n8L9KSOivpZZ9vm9ppUhB/6uSMk8t/N8VU1BkBmZM7a1J86hTYBDaOtQGkp83lWmpz6RRY97CBtZPLtdRGNxCA0TfgQS0UgFELeVALBWDUQh7UQgEYtZAHtVAARi3kQS3Ut4Wmh36lHBcu9aNDu9QnhbFH1uFYJYsxVkEmY7ueB1s3tGQup9C1+G0M8ZZEfDgLGN62jZn0ijbcVRRFURSGyh99hvnZRVwBKgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.8f43419ce90aed4791a35ad8ea522ed0.svg";
export { ForwardRef as ReactComponent };